var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { injectScript } from "../utilities/dom-mutations";
import { jsonParser } from "../utilities/parsers";
import { BaseProvider } from "./base.provider";
export class NsoftProvider extends BaseProvider {
    messageHandler(data) {
        if (data.message && data.message.type) {
            switch (data.message.type) {
                case "loginRequired":
                    window.verticalBridge.authenticate();
                    break;
                case "logout":
                    break;
                case "ticketResolved":
                    // Balance refresh should not be necessary?
                    // homePage.RefreshCashBalance();
                    break;
                case "roundFinished":
                    // Balance refresh should not be necessary?
                    // homePage.RefreshCashBalance();
                    break;
                case "logoutSuccess":
                    break;
                case "listenersReady":
                    break;
            }
        }
    }
    iframeResizer() {
        const { clientScriptData } = this.launchData;
        const scriptData = jsonParser(clientScriptData);
        if (scriptData &&
            scriptData.returnUrl &&
            navigator &&
            navigator.userAgent &&
            !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/)) {
            window.location.href = `https://7platform.com/navigate.html?url=${scriptData.returnUrl}`;
        }
        const iFrameResizeInitObject = {
            checkOrigin: [scriptData.launchUrlBase],
            initCallback(iframe) {
                var _a;
                iframe.contentWindow.postMessage({
                    type: "balanceChanged",
                    content: {
                        // TODO: Make sure about this, this is an object with properties like cash etc.
                        balance: (_a = this.user) === null || _a === void 0 ? void 0 : _a.accountBalances,
                    },
                }, this.scriptData.launchUrlBase);
            },
            messageCallback: this.messageHandler,
            heightCalculationMethod: "lowestElement",
        };
        window === null || window === void 0 ? void 0 : window.iFrameResize(iFrameResizeInitObject);
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            const { externalJsScripts } = this.launchData;
            const mappedScripts = externalJsScripts.map((ejs, index) => {
                return {
                    hid: `nsoftexternalscript-${index}`,
                    src: ejs.url,
                    callback: () => this.iframeResizer(),
                };
            });
            injectScript(mappedScripts);
        });
    }
}
